module.exports = __webpack_public_path__ + "img/card4_min.619f11b5.png";